import request from '@/utils/request.js'
import axios from 'axios'
const project = 'sora'

function safeParseJson(value) {
    if (typeof value !== 'string') {
        return value
    }
    try {
        return JSON.parse(value)
    } catch (e) {
        return value
    }
}

function normalizeModelName(model) {
    if (typeof model !== 'string') {
        return model
    }
    return model.trim().toLowerCase().replace(/\./g, '_').replace(/-/g, '_')
}

function ensureArray(value) {
    if (Array.isArray(value)) {
        return value.filter(item => item !== '' && item !== null && typeof item !== 'undefined')
    }
    if (value === '' || value === null || typeof value === 'undefined') {
        return []
    }
    return [value]
}

function normalizeCreateTaskPayload(rawData = {}) {
    const payload = { ...rawData }
    const parsedData = safeParseJson(payload.data)
    const data = parsedData && typeof parsedData === 'object' ? { ...parsedData } : {}

    if (typeof payload.prompt === 'string') {
        payload.prompt = payload.prompt.trim()
    }

    if (!payload.prompt && typeof data.prompt === 'string') {
        payload.prompt = data.prompt.trim()
    }

    if (typeof payload.template_id === 'undefined') {
        payload.template_id = 0
    }
    if (typeof payload.parent_id === 'undefined') {
        payload.parent_id = 0
    }
    if (typeof payload.model_version === 'undefined' || payload.model_version === '') {
        payload.model_version = 'sora2'
    }
    if (typeof payload.is_hd === 'undefined' || payload.is_hd === '') {
        payload.is_hd = 0
    }
    if (typeof payload.is_watermark === 'undefined' || payload.is_watermark === '') {
        payload.is_watermark = 0
    }
    if (typeof payload.duration === 'undefined' || payload.duration === '') {
        payload.duration = 4
    }
    if (typeof payload.size === 'undefined' || payload.size === '') {
        payload.size = '16:9'
    }

    if (!Array.isArray(data.image_urls) && typeof data.image_urls === 'undefined') {
        data.image_urls = ensureArray(data.refer_images)
    }

    data.image_urls = ensureArray(data.image_urls)
    data.cover_image_urls = ensureArray(data.cover_image_urls)
    data.refer_images = ensureArray(data.refer_images)

    if (typeof data.aspect_ratio === 'string' && data.aspect_ratio) {
        payload.size = data.aspect_ratio
    }

    const normalizedModel = normalizeModelName(data.model)
    if (normalizedModel && normalizedModel !== 'pro') {
        payload.model_version = normalizedModel
    }

    if (typeof data.duration !== 'undefined' && data.duration !== '') {
        const durationNum = Number(data.duration)
        if (!Number.isNaN(durationNum)) {
            payload.duration = durationNum
        }
    }

    let mode = typeof data.mode === 'string' ? data.mode.toLowerCase() : ''
    if (mode === '4k') {
        payload.is_hd = 2
    } else if (typeof data.size === 'string') {
        const resolution = data.size.toLowerCase()
        if (resolution === '720p') {
            payload.is_hd = 0
        }
        if (resolution === '1080p') {
            payload.is_hd = 1
        }
    }

    if (normalizedModel === 'pro' && !mode) {
        data.mode = 'pro'
        mode = 'pro'
    }

    const imageUrls = ensureArray(data.image_urls)
    const coverImageUrls = ensureArray(data.cover_image_urls)

    if (!mode) {
        if (payload.is_hd === 2) {
            mode = '4k'
        } else {
            mode = 'default'
        }
    }

    const resolutionByHd = {
        0: '720p',
        1: '1080p'
    }

    let dataSize = typeof data.size === 'string' ? data.size.toLowerCase() : ''
    if (payload.is_hd === 2) {
        if (dataSize !== '720p' && dataSize !== '1080p') {
            dataSize = '1080p'
        }
    } else {
        dataSize = resolutionByHd[payload.is_hd] || '720p'
    }

    // is_hd=2 代表 4K，不论 mode 是什么都强制覆盖为 '4k'（pro 模式除外）
    if (payload.is_hd === 2 && mode !== 'pro') {
        mode = '4k'
    }

    // 统一输出文档约定的 data 字段结构，保留原有扩展字段。
    data.model = payload.model_version
    data.prompt = payload.prompt || data.prompt || ''
    data.refer_images = imageUrls
    data.image_urls = imageUrls
    data.cover_image_urls = coverImageUrls
    data.aspect_ratio = payload.size
    data.size = dataSize
    data.duration = String(payload.duration)
    data.mode = mode

    if (typeof payload.ctype !== 'undefined' && payload.ctype !== '') {
        const ctypeNum = Number(payload.ctype)
        if (!Number.isNaN(ctypeNum)) {
            payload.ctype = ctypeNum
        }
    }

    payload.data = data
    return payload
}



const $http = {
    getLingganList:(data)=>{
        return request.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/goodexample/?md5_key=${data.md5_key}&order=${data.order}&prompt=${data.prompt}&page_no=${data.page_no}&page_size=${data.page_size}`)
    },
    //https://payadmin.m.nengshuohuihua.com
    useexample:(data)=>{
        return request.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/?id=${data.id}&md5_key=${data.md5_key}`)
    },
    getTgConf:(data)=>{
        return request.get(`https://apimid.m.nengshuohuihua.com/wap/tgpage/landingpage/?md5_key=${data.md5key}`)
        // return request.get(`http://127.0.0.1:3000/wap/tgpage/landingpage/?md5_key=${data.md5key}`)

    },
    sendLandingPv:(data) => {
        return request.post(`https://apimid.m.nengshuohuihua.com/wap/tgpage/landingpv/`, {...data})
    },
    
    //充值挡位
    membership:(data)=>{
        return request.get(`/front/${project}/pay/membership/`,{...data})
    },
    //充值
    chongzhi:(data)=>{
        return request.post(`/front/${project}/pay/chongzhi/`,{...data})
    },
    //充值状态
    chongzhiStatus:(data)=>{
        return request.get(`/pay/order/status/?uniq_key=${data}`)
    },
    // 查询用户信息
    profile:(data)=>{
        return request.get(`/front/user/profile/`,{...data})
    },
    //今日是否有订单
    today_order:(data)=>{
        return request.get(`/front/${project}/pay/today_order/`,{...data})
    },
    //样例
    getSampleLIst:(data)=>{
        return request.get(`/front/${project}/sample/`,{...data})

    },

    //删除作品
    deleteItem:(data)=>{
        return request.delete(`/front/${project}/task/${data}/`)
    },

     //点赞作品
    voteItem:(data, type)=>{
        return request.get(`/front/${project}/votes/${data}/?type=${type}`)
    },

    // 微信登录二维码
    wx_imagecode:(data)=>{
        return request.get(`/front/wx/imagecode/?authorizer_appid=${APP_ID}`,{...data})
    },
    // 微信登录二维码查询状态
    wx_imagecodelogin:(data)=>{
        return request.get(`/front/wx/imagecodelogin/`,{...data})
    },

    // 账号登录
    phone_login:(data)=>{
        return request.post(`/front/auth/login/phone/`,{...data})
    },
    // 获取验证码
    auth_smscode:(data)=>{
        return request.post(`/front/auth/smscode/`,{...data})
    },
    // 注册
    post_reg:(data)=>{
        return request.post(`/front/auth/reg/`,{...data})
    },
    // 找回密码
    post_resetpwd:(data)=>{
        return request.post(`/front/auth/resetpwd/`,{...data})
    },
    // 广场列表
    auth_resetpwd:(data)=>{
        console.log('data')
        console.log(data)
        return request.get(`/front/${project}/index/?template_id=${data.template_id}`,)
    },

    face_template:(data)=>{
        return request.get(`/front/${project}/template/`,{...data})
    },


    /* 个人资料相关 */
    // 上传头像
    upload_avatar:(data)=>{
        return request.post(`/front/user/profile/avatar/`,{...data})
    },


    //开始创作
    beginCreate:(data)=>{
        return request.post(`/front/${project}/start/`, normalizeCreateTaskPayload(data))
    },

    //获取任务状态
    getTaskStatus:(data)=>{
        return request.post(`/front/${project}/start/statuslist/`,{...data})
    },
    //获取用户生成的作品列表
    getUserCreList:(data)=>{
        return request.get(`/front/${project}/user/pieces/`,{...data})
    },
     // 每日数据 Every_day
    Every_day:(data)=>{
        return request.get(`/front/${project}/num/`,{...data})
    },

    // 退款
    post_refund:(data)=>{
        return request.post(`/front/${project}/pay/refund/`,{...data})
    },
    // 退款订单查询
    get_refund:(data)=>{
        return request.get(`/front/${project}/pay/refund/`,{...data})
    },
    // 查询认证结果
    faceverify_check:(data)=>{
        return request.get(`/front/auth/faceverify/check/`,{...data})
    },
    // 实人认证
    auth_faceverify:(data)=>{
        return request.post(`/front/auth/faceverify/`,{...data})
    },
    //绑定手机号
    bind_phone:(data)=>{
        return request.put(`/front/user/bind/phone/`,{...data})
    },
    // 绑定微信 - 获取公众号二维码
    getBindQrcode: (data = {}) => {
        return request.post(`/front/user/bind/wx/?authorizer_appid=${APP_ID}`, { ...data })
    },
    // 绑定微信 - 查询绑定状态
    checkBindStatus: (data = {}) => {
        return request.get(`/front/user/bind/wx/`, { ...data })
    },
    // 获取cookieId
    getCookerId:(data)=>{
        return request.post(`/wap/adpv/record/`,{...data})
    },

    // 查询获取工具箱
    templateList:(data)=>{
        return request.get(`/front/${project}/template/`,{...data})
    },
    // 添加模板到我的
    downImag:(data)=>{
        console.log(data)
       return request.get(`/front/${project}/down/`,{...data})
    },
    // 添加模板到我的
    adduser_template:(data)=>{
        return request.post(`/front/${project}/user_template/`,{...data})
    },
    // 删除我的模板
    deluser_template:(data)=>{
        return request.delete(`/front/${project}/user_template/?template_id=${data.template_id}`, {
             headers: {'Content-Type':'application/json'},
             data:{}
        })
    },

    // AI 提示词
    Aiprompt:(data)=>{
        return request.post(`/front/${project}/prompt/`, {...data})
    },
    // 接口下载
    downloadItem:(data)=>{
        return request.get(`/front/${project}/download/${data}/`, )
    },
}

export default $http
